import script from "./ZoneWinners.vue?vue&type=script&setup=true&lang=js"
export * from "./ZoneWinners.vue?vue&type=script&setup=true&lang=js"

import "./ZoneWinners.vue?vue&type=style&index=0&id=5230b739&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\100\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5230b739"]])

export default __exports__